import { ProductCategoryFactory, ProductCategoryMapperParameter } from "@/v2/models/product-categories.js";
import httpMixin from "@/v2/mixins/http.js";
import mapperMixin from "@/v2/mixins/mapper.js";

export default {
    mixins: [httpMixin, mapperMixin],
    methods: {
        _productCategoryMapper(productCategory) {
            return {
                id: productCategory.id,
                parent_id: productCategory.parent_id,
                image_id: productCategory.image_id,
                name: productCategory.name,
                full_name: productCategory.full_name,
                parent_name: productCategory.parent_name,
                slug: productCategory.slug,
                product_count: productCategory.product_count,
                created_at: new Date(productCategory.created_at),
                updated_at: new Date(productCategory.updated_at),
                deleted_at: new Date(productCategory.deleted_at),
                bo_can_delete: true,
                show_action_menu: true,
            };
        },

        parseProductCategory(productCategory) {
            return ProductCategoryFactory.construct(
                this.createMapperParameter(new ProductCategoryMapperParameter()),
                productCategory
            );
        },

        parseProductCategories(productCategories) {
            let parsedProductCategories = [];

            productCategories.forEach((productCategoryData) => {
                const productCategory = this.parseProductCategory(productCategoryData);
                parsedProductCategories.push(productCategory);
            });

            return parsedProductCategories;
        },

        getProductCategory(id, url, payload, success, failure) {
            return this.getData(
                url + "/" + id,
                payload,
                (response) => {
                    success(this.parseProductCategory(response.data));
                },
                failure
            );
        },

        getProductCategories(url, payload, success, failure) {
            return this.getData(
                url,
                payload,
                (response) => {
                    success(this.parseProductCategories(response.data.data), response.data.meta);
                },
                failure
            );
        },
    },
};
